import { application } from "./controllers/index";

import ToggleVisibilityOnValueController from "./controllers/toggle_visibility_on_value_controller";
application.register("toggle-visibility-on-value", ToggleVisibilityOnValueController);

import ProductVariantCardController from "./controllers/product_variant_card_controller";
application.register("product-variant-card", ProductVariantCardController);

import ProductVariantCardTwController from "./controllers/product_variant_card_tw_controller";
application.register("product-variant-card-tw", ProductVariantCardTwController);

import UpdateQuantityController from "./controllers/update_quantity_controller";
application.register("update-quantity", UpdateQuantityController);

import URLPlaceholderController from "./controllers/url_placeholder_controller";
application.register("url-placeholder", URLPlaceholderController);

import AddToCartController from "./controllers/add_to_cart_controller";
application.register("add-to-cart", AddToCartController);

import DateRangeController from "./controllers/date_range_controller";
application.register("date-range", DateRangeController);

import PieController from "./controllers/pie_controller";
application.register("pie", PieController);

import HeaderSearchController from "./controllers/header_search_controller";
application.register("header-search", HeaderSearchController);

import SendSubmissionController from "./controllers/send_submission_controller";
application.register("send-submission", SendSubmissionController);

import JolifishSwiperController from "./controllers/jolifish_swiper_controller";
application.register("jolifish-swiper", JolifishSwiperController);

import TurnstileController from "./controllers/turnstile_controller";
application.register("turnstile", TurnstileController);

import TextAnimationController from "./controllers/text_animation_controller";
application.register("text-animation", TextAnimationController);

import HideClosestModalController from "./controllers/hide_closest_modal_controller";
application.register("hide-closest-modal", HideClosestModalController);

import ModelViewerController from "./controllers/model_viewer_controller";
application.register("model-viewer", ModelViewerController);

import CheckallController from "./controllers/checkall_controller";
application.register("checkall", CheckallController);

import CheckboxLikeRadioController from "./controllers/checkbox_like_radio_controller";
application.register("checkbox-like-radio", CheckboxLikeRadioController);

import NavigateBackController from "./controllers/navigate_back_controller";
application.register("navigate-back", NavigateBackController);

import RedirectClickController from "./controllers/redirect_click_controller";
application.register("redirect-click", RedirectClickController);

import StopProgationController from "./controllers/stop_propagation_controller";
application.register("stop-propagation", StopProgationController);

import OrderFileController from "./controllers/order_file_controller";
application.register("order-file", OrderFileController);

import DeleteFileController from "./controllers/delete_file_controller";
application.register("delete-file", DeleteFileController);

import NavigateVariantController from "./controllers/navigate_variant_controller";
application.register("navigate-variant", NavigateVariantController);

import FilterCheckboxController from "./controllers/filter_checkbox_controller";
application.register("filter-checkbox", FilterCheckboxController);

import AccountImageController from "./controllers/account_image_controller";
application.register("account-image", AccountImageController);

import InternationalPhoneInputController from "./controllers/international_phone_input_controller";
application.register("international-phone-input", InternationalPhoneInputController);

import InputMaskController from "./controllers/input_mask_controller";
application.register("input-mask", InputMaskController);

import PopperController from "./controllers/popper_controller";
application.register("popper", PopperController);

import AutoSubmitController from "./controllers/auto_submit_controller";
application.register("auto-submit", AutoSubmitController);

import AutoRequestSubmitController from "./controllers/auto_request_submit_controller";
application.register("auto-request-submit", AutoRequestSubmitController);

import OptionChoiceGroupController from "./controllers/option_choice_group_controller";
application.register("option-choice-group", OptionChoiceGroupController);

import ProductAvailabilityController from "./controllers/product_availability_controller";
application.register("product-availability", ProductAvailabilityController);

import OrderNotesController from "./controllers/order_notes_controller";
application.register("order-notes", OrderNotesController);

import ToggleVisibilityController from "./controllers/toggle_visibility_controller";
application.register("toggle-visibility", ToggleVisibilityController);

import ShowSpinnerOnSubmitController from "./controllers/show_spinner_on_submit_controller";
application.register("show-spinner-on-submit", ShowSpinnerOnSubmitController);

import ToggleElementController from "./controllers/toggle_element_controller";
application.register("toggle-element", ToggleElementController);

import SearchFieldController from "./controllers/search_field_controller";
application.register("search-field", SearchFieldController);

import OrderAccordeonController from "./controllers/order_accordeon_controller";
application.register("order-accordeon", OrderAccordeonController);

import AdminBarController from "./controllers/admin_bar_controller";
application.register("admin-bar", AdminBarController);

import CloseModalController from "./controllers/close_modal_controller";
application.register("close-modal", CloseModalController);

import MasonryController from "./controllers/masonry_controller";
application.register("masonry", MasonryController);

import InfoboxController from "./controllers/infobox_controller";
application.register("infobox", InfoboxController);

import InstalikeController from "./controllers/instalike_controller";
application.register("instalike", InstalikeController);

import ContainedImageController from "./controllers/contained_image_controller";
application.register("contained-image", ContainedImageController);

import ThumbCarouselController from "./controllers/thumb_carousel_controller";
application.register("thumb-carousel", ThumbCarouselController);

import FilterCounterController from "./controllers/filter_counter_controller";
application.register("filter-counter", FilterCounterController);

import PermissionsEditorController from "./controllers/permissions_editor_controller";
application.register("permissions-editor", PermissionsEditorController);

import PreserveScrollController from "./controllers/preserve_scroll_controller";
application.register("preserve-scroll", PreserveScrollController);

import AudioPickerController from "./controllers/audio_picker_controller";
application.register("audio-picker", AudioPickerController);

import FlatpickrController from "./controllers/flatpickr_controller";
application.register("flatpickr", FlatpickrController);

import LightboxController from "./controllers/lightbox_controller";
application.register("lightbox", LightboxController);

import OrdersUsersSelectController from "./controllers/orders_users_select_controller";
application.register("orders-users-select", OrdersUsersSelectController);

import HideOnErrorController from "./controllers/hide_on_error_controller";
application.register("hide-on-error", HideOnErrorController);

import OpenOffcanvasController from "./controllers/open_offcanvas_controller";
application.register("open-offcanvas", OpenOffcanvasController);
